export default {
  system: {
    zh_cn: '系统',
    zhhant: '系統',
    en: 'System',
    he: 'מערכת',
    de: 'System',
    es: 'Sistema',
    ru: 'Система',
    vi: 'Hệ thống',
  },
  advancedSettings: {
    zh_cn: '高级设置',
    zhhant: '高級設置',
    en: 'Advanced Settings',
    he: 'הגדרות מתקדמות',
    de: 'Erweiterte Einstellungen',
    es: 'Configuraciones avanzadas',
    ru: 'Расширенные настройки',
    vi: 'Cài đặt nâng cao',
  },
  cusexportTip: {
    zh_cn: '自定义导出: 只支持日维度账单, 且最多导出31天账单, 其他场景点击列表操作中的导出按钮',
    zhhant: '自定義導出: 只支持日維度帳單, 且最多導出31天帳單, 其他場景點擊列表操作中的導出按鈕',
    en: 'Custom export: Only supports daily billing and can only export up to 31 days of bills. For other scenarios, click the Export button in List Operations',
    he: 'ייצוא מותאם אישית: תומך רק בחשבוניות יומיות ויכול לייצא עד 31 ימים של חשבוניות. עבור תרחישים אחרים, לחץ על כפתור הייצוא בפעולות ברשימה',
    de: 'Benutzerdefinierter Export: Unterstützt nur tägliche Abrechnung und kann bis zu 31 Tage Rechnungen exportieren. Für andere Szenarien, klicken Sie auf die Schaltfläche Exportieren in Listenoperationen',
    es: 'Exportación personalizada: solo admite facturación diaria y puede exportar hasta 31 días de facturas. Para otros escenarios, haga clic en el botón Exportar en Operaciones de lista',
    ru: 'Пользовательский экспорт: поддерживает только дневную выставку счетов и может экспортировать до 31 дней счетов. Для других сценариев нажмите кнопку Экспорт в разделе "Операции по спискам"',
    vi: 'Xuất tùy chỉnh: Chỉ hỗ trợ hóa đơn theo ngày và chỉ có thể xuất tối đa 31 ngày hóa đơn. Đối với các trường hợp khác, nhấp vào nút Xuất trong Thao tác danh sách',
  },
  export: {
    zh_cn: '导出',
    zhhant: '導出',
    en: 'Export',
    he: 'ייצא',
    de: 'Exportieren',
    es: 'Exportar',
    ru: 'Экспорт',
    vi: 'Xuất',
  },
  diagnostics: {
    zh_cn: '触发',
    zhhant: '觸發',
    en: 'Diagnostics',
    he: 'תקלות',
    de: 'Diagnose',
    es: 'Diagnóstico',
    ru: 'Диагностика',
    vi: 'Điagnostic',
  },
  paymentChannel: {
    zh_cn: '支付通道',
    zhhant: '支付通道',
    en: 'Payment Channel',
    he: 'ערוץ תשלום',
    de: 'Zahlungskanal',
    es: 'Canal de pago',
    ru: 'Канал оплаты',
    vi: 'Kênh thanh toán',
  },
  runlog: {
    zh_cn: '运行日志',
    zhhant: '運行日誌',
    en: 'Diagnostics',
    he: 'תקלות',
    de: 'Diagnose',
    es: 'Diagnóstico',
    ru: 'Диагностика',
    vi: 'Điagnostic',
  },
  missingOperator: {
    zh_cn: '缺少商户信息',
    zhhant: '缺少商戶信息',
    en: 'Missing operator information',
    he: 'חסר מידע על המפעיל',
    de: 'Fehlende Betreiberinformationen',
    es: 'Falta información del operador',
    ru: 'Отсутствует информация об операторе',
    vi: 'Thiếu thông tin nhà điều hành',
  },
  permissionDenied: {
    zh_cn: '没有权限,拒绝访问',
    zhhant: '沒有權限,拒絕訪問',
    en: 'Permission Denied',
    he: 'הגישה נדחתה',
    de: 'Zugriff verweigert',
    es: 'Permiso Denegado',
    ru: 'Доступ запрещен',
    vi: 'Quyền truy cập bị từ chối',
  },
  needSuperRolePerm: {
    zh_cn: '需要超级管理员角色权限',
    zhhant: '需要超級管理員角色權限',
    en: 'Need Super Role Permission',
    he: 'נדרשת הרשאת תפקיד על',
    de: 'Superrollenberechtigung erforderlich',
    es: 'Se requiere permiso de rol superadministrador',
    ru: 'Необходимы права на роль Супер',
    vi: 'Cần quyền phân quyền siêu cấp',
  },
  selectable: {
    zh_cn: '可选',
    zhhant: '可選',
    en: 'Selectable',
    he: 'בחר',
    de: 'Wählbar',
    es: 'Seleccionable',
    ru: 'Выбираемый',
    vi: 'Có thể chọn',
  },
  selected: {
    zh_cn: '已选',
    zhhant: '已選',
    en: 'Selected',
    he: 'נבחר',
    de: 'Ausgewählt',
    es: 'Seleccionado',
    ru: 'Выбрано',
    vi: 'Đã chọn',
  },
  superRolePerm: {
    zh_cn: '超级管理员角色, 拥有所有权限',
    zhhant: '超級管理員角色, 擁有所有權限',
    en: 'Super Role, has all permissions',
    he: 'תפקיד על, יש את כל ההרשאות',
    de: 'Superrolle, hat alle Berechtigungen',
    es: 'Rol Superadministrador, tiene todos los permisos',
    ru: 'Суперроль, имеет все права',
    vi: 'Vai trò siêu cấp, có tất cả quyền hạn',
  },
  roleName: {
    zh_cn: '角色名称',
    zhhant: '角色名稱',
    en: 'Role Name',
    he: 'שם התפקיד',
    de: 'Rollenname',
    es: 'Nombre del Rol',
    ru: 'Название роли',
    vi: 'Tên vai trò',
  },
  role: {
    zh_cn: '角色',
    zhhant: '角色',
    en: 'Role',
    he: 'תפקיד',
    de: 'Rolle',
    es: 'Rol',
    ru: 'Роль',
    vi: 'Vai trò',
  },
  roleEdit: {
    zh_cn: '角色编辑',
    zhhant: '角色編輯',
    en: 'Role Edit',
    he: 'עריכת תפקיד',
    de: 'Rolle bearbeiten',
    es: 'Editar Rol',
    ru: 'Редактирование роли',
    vi: 'Chỉnh sửa vai trò',
  },
  roleAdd: {
    zh_cn: '角色添加',
    en: 'Role Add',
    zhhant: '角色添加',
    he: 'הוספת תפקיד',
    de: 'Rolle hinzufügen',
    es: 'Añadir rol',
    ru: 'Добавить роль',
    vi: 'Thêm vai trò',
  },
  addManager: {
    zh_cn: '添加管理员',
    zhhant: '添加管理員',
    en: 'Add Manager',
    he: 'הוסף מנהל',
    de: 'Manager hinzufügen',
    es: 'Agregar Administrador',
    ru: 'Добавить администратора',
    vi: 'Thêm quản trị viên',
  },
  editManager: {
    zh_cn: '编辑管理员',
    zhhant: '編輯管理員',
    en: 'Edit Manager',
    he: 'ערוך מנהל',
    de: 'Manager bearbeiten',
    es: 'Editar Administrador',
    ru: 'Редактировать администратора',
    vi: 'Chỉnh sửa quản trị viên',
  },
  lately: {
    zh_cn: '最近',
    zhhant: '最近',
    en: 'lately',
    he: 'אחרון',
    de: 'Kürzlich',
    es: 'Reciente',
    ru: 'Недавний',
    vi: 'Gần đây',
  },
  showMenus: {
    zh_cn: '显示菜单',
    zhhant: '顯示菜單',
    en: 'Show Menus',
    he: 'הצג תפריטים',
    de: 'Menüs anzeigen',
    es: 'Mostrar Menús',
    ru: 'Показать меню',
    vi: 'Hiển thị menu',
  },
  showDatas: {
    zh_cn: '显示数据权限',
    zhhant: '顯示數據權限',
    en: 'Show Operator Data',
    he: 'הצג נתוני מפעיל',
    de: 'Operator-Daten anzeigen',
    es: 'Mostrar Datos del Operador',
    ru: 'Показать данные оператора',
    vi: 'Hiển thị dữ liệu của người dùng',
  },
  operatorName: {
    zh_cn: '运营商',
    zhhant: '运营商',
    en: 'Operator Name',
    he: 'Operator Name',
    de: 'Operator Name',
    es: 'Operator Name',
    ru: 'Operator Name',
    vi: 'Tên Nhà Mạng',
  },
  forgetPassword: {
    zh_cn: '忘记密码？',
    zhhant: '忘記密碼？',
    en: 'Forgot your password?',
    he: 'שכחת את הסיסמה?',
    de: 'Passwort vergessen?',
    es: '¿Olvidaste tu contraseña?',
    ru: 'Забыли пароль?',
    vi: 'Quên mật khẩu?',
  },
  login: {
    zh_cn: '登 录',
    zhhant: '登錄',
    en: 'Login',
    he: 'התחברות',
    de: 'Anmelden',
    es: 'Iniciar sesión',
    ru: 'Войти',
    vi: 'Đăng nhập',
  },
  username: {
    zh_cn: '用户名',
    zhhant: '用戶名',
    en: 'Username',
    he: 'שם משתמש',
    de: 'Benutzername',
    es: 'Nombre de usuario',
    ru: 'Имя пользователя',
    vi: 'Tên người dùng',
  },
  clientid: {
    zh_cn: '客户端 ID',
    zhhant: '客戶端 ID',
    en: 'Client ID',
    he: 'מזהה לקוח',
    de: 'Client-ID',
    es: 'ID de Cliente',
    ru: 'ID клиента',
    vi: 'ID khách hàng',
  },
  password: {
    zh_cn: '密码',
    zhhant: '密碼',
    en: 'Password',
    he: 'סיסמה',
    de: 'Passwort',
    es: 'Contraseña',
    ru: 'Пароль',
    vi: 'Mật khẩu',
  },
  solution: {
    zh_cn: '解决方式',
    zhhant: '解決方式',
    en: 'Solution',
    he: 'פתרון',
    de: 'Lösung',
    es: 'Solución',
    ru: 'Решение',
    vi: 'Giải pháp',
  },
  state: {
    zh_cn: '状态',
    zhhant: '狀態',
    en: 'Status',
    he: 'סטטוס',
    de: 'Status',
    es: 'Estado',
    ru: 'Состояние',
    vi: 'Trạng thái',
  },
  tags: {
    zh_cn: '标签',
    zhhant: '標籤',
    en: 'Tags',
    he: 'תגים',
    de: 'Tags',
    es: 'Etiquetas',
    ru: 'Теги',
    vi: 'Thẻ',
  },
  otherMethodsLogin: {
    zh_cn: '或者使用其他方式登录',
    zhhant: '或者使用其他方式登入',
    en: 'Or login with other methods',
    he: 'או התחבר עם שיטות אחרות',
    de: 'Oder mit anderen Methoden anmelden',
    es: 'O inicia sesión con otros métodos',
    ru: 'Или войдите другими способами',
    vi: 'Hoặc đăng nhập bằng phương thức khác',
  },
  skip: {
    zh_cn: '跳过',
    zhhant: '跳過',
    en: 'Skip',
    he: 'דלג',
    de: 'Überspringen',
    es: 'Omitir',
    ru: 'Пропустить',
    vi: 'Bỏ qua',
  },
  skipTip: {
    zh_cn: '下次登录时将再次提示您修改默认密码，您也可以稍后在系统 > 用户菜单中进行修改。',
    zhhant: '下次登錄時將再次提示您修改預設密碼，您也可以稍後在系統 > 使用者菜單中進行修改。',
    en: 'You will be prompted to change the default password again when you log in next time, and you can also change it later in the System > User.',
    he: 'תתבקש לשנות את הסיסמה ברירת המחדל שוב כאשר תתחבר בפעם הבאה, ותוכל לשנות אותה גם מאוחר יותר במערכת > משתמש.',
    de: 'Sie werden beim nächsten Einloggen aufgefordert, das Standardpasswort erneut zu ändern. Sie können es auch später im System > Benutzer ändern.',
    es: 'Se te pedirá que cambies la contraseña predeterminada nuevamente cuando inicies sesión la próxima vez, y también podrás cambiarla más tarde en Sistema > Usuario.',
    ru: 'В следующий раз при входе вам будет предложено снова изменить пароль по умолчанию, также вы можете изменить его позже в разделе Система > Пользователь.',
    vi: 'Bạn sẽ được nhắc thay đổi mật khẩu mặc định khi đăng nhập lần sau, và bạn cũng có thể thay đổi mật khẩu đó sau này trong Hệ thống > Người dùng.',
  },
  copied: {
    zh_cn: '复制成功！',
    zhhant: '複製成功！',
    en: 'Copied Successfully!',
    he: 'הועתק בהצלחה!',
    de: 'Erfolgreich kopiert!',
    es: '¡Copiado con éxito!',
    ru: 'Успешно скопировано!',
    vi: 'Sao chép thành công!',
  },
  copy: {
    zh_cn: '复制',
    zhhant: '複製',
    en: 'Copy',
    he: 'העתק',
    de: 'Kopieren',
    es: 'Copiar',
    ru: 'Копировать',
    vi: 'Sao chép',
  },
  generate: {
    zh_cn: '生成',
    zhhant: '生成',
    en: 'Generate',
    he: 'צור',
    de: 'Generieren',
    es: 'Generar',
    ru: 'Создать',
    vi: 'Tạo',
  },
  warning: {
    zh_cn: '警告',
    zhhant: '警告',
    en: 'Warning',
    he: 'אזהרה',
    de: 'Warnung',
    es: 'Advertencia',
    ru: 'Предупреждение',
    vi: 'Cảnh báo',
  },
  bind: {
    zh_cn: '绑定设备',
    zhhant: '綁定設備',
    en: 'Bind',
    he: 'קשר',
    de: 'Binden',
    es: 'Vincular',
    ru: 'Привязать',
    vi: 'Gắn',
  },
  view: {
    zh_cn: '详情',
    zhhant: '詳細資料',
    en: 'View',
    he: 'צפה',
    de: 'Ansicht',
    es: 'Ver',
    ru: 'Просмотр',
    vi: 'Xem',
  },
  edit: {
    zh_cn: '编辑',
    zhhant: '編輯',
    en: 'Edit',
    he: 'ערוך',
    de: 'Bearbeiten',
    es: 'Editar',
    ru: 'Редактировать',
    vi: 'Chỉnh sửa',
  },
  audit: {
    zh_cn: '审核',
    zhhant: '審核',
    en: 'Audit',
    he: 'אודיט',
    de: 'Prüfung',
    es: 'Auditoría',
    ru: 'Аудит',
    vi: 'Kiểm tra',
  },
  revocation: {
    zh_cn: '撤销',
    zhhant: '撤銷',
    en: 'Revocation',
    he: 'ביטול',
    de: 'Widerruf',
    es: 'Revocación',
    ru: 'Отзыв',
    vi: 'Thu hồi',
  },
  save: {
    zh_cn: '保存',
    zhhant: '儲存',
    en: 'Save',
    he: 'שמור',
    de: 'Speichern',
    es: 'Guardar',
    ru: 'Сохранить',
    vi: 'Lưu',
  },
  gening: {
    zh_cn: '生成中',
    zhhant: '生成中',
    en: 'Generating...',
    he: 'יוצר ...',
    de: 'Wird generiert...',
    es: 'Generando...',
    ru: 'Генерируется...',
    vi: 'Đang tạo...',
  },
  done: {
    zh_cn: '完成',
    zhhant: '完成',
    en: 'Done',
    he: 'בוצע',
    de: 'Fertig',
    es: 'Hecho',
    ru: 'Готово',
    vi: 'Xong',
  },
  saveChanges: {
    zh_cn: '保存',
    zhhant: '保存',
    en: 'Save Changes',
    he: 'שמור שינויים',
    de: 'Änderungen speichern',
    es: 'Guardar Cambios',
    ru: 'Сохранить изменения',
    vi: 'Lưu thay đổi',
  },
  query: {
    zh_cn: '查询',
    zhhant: '查詢',
    en: 'Query',
    he: 'שאריך',
    de: 'Abfrage',
    es: 'Consulta',
    ru: 'Запрос',
    vi: 'Truy vấn',
  },
  apply: {
    zh_cn: '应用',
    zhhant: '應用',
    en: 'Apply',
    he: 'החל',
    de: 'Anwenden',
    es: 'Aplicar',
    ru: 'Применить',
    vi: 'Áp dụng',
  },
  diagnosticsAt: {
    zh_cn: '触发时间',
    zhhant: '觸發時間',
    en: 'Diagnostics At',
    he: 'בדיקת תאריך',
    de: 'Diagnose am',
    es: 'Diagnosticado en',
    ru: 'Диагностика',
    vi: 'Điều tra lúc',
  },
  auth: {
    zh_cn: '授权',
    zhhant: '授權',
    en: 'Auth',
    he: 'אישור',
    de: 'Autorisierung',
    es: 'Autenticación',
    ru: 'Авторизация',
    vi: 'Xác minh',
  },
  unauth: {
    zh_cn: '取消授权',
    zhhant: '取消授權',
    en: 'Unauth',
    he: 'ביטול אישור',
    de: 'Autorisierung aufheben',
    es: 'Revocar autenticación',
    ru: 'Отменить авторизацию',
    vi: 'Hủy xác minh',
  },
  create: {
    zh_cn: '创建',
    zhhant: '創建',
    en: 'Create',
    he: 'צור',
    de: 'Erstellen',
    es: 'Crear',
    ru: 'Создать',
    vi: 'Tạo',
  },
  usedAt: {
    zh_cn: '授权时间',
    zhhant: '授權時間',
    en: 'Used At',
    he: 'נעשה שימוש בתאריך',
    de: 'Verwendet am',
    es: 'Usado en',
    ru: 'Использовано',
    vi: 'Được sử dụng lúc',
  },
  createdAt: {
    zh_cn: '创建时间',
    zhhant: '創建時間',
    en: 'Created At',
    he: 'נוצר בתאריך',
    de: 'Erstellt am',
    es: 'Creado en',
    ru: 'Создано',
    vi: 'Được tạo lúc',
  },
  updatedAt: {
    zh_cn: '最后更新时间',
    zhhant: '最後更新時間',
    en: 'Updated At',
    he: 'עודכן בתאריך',
    de: 'Aktualisiert am',
    es: 'Actualizado en',
    ru: 'Обновлено',
    vi: 'Cập nhật lúc',
  },
  unlock: {
    zh_cn: '解锁',
    zhhant: '解鎖',
    en: 'Unlock',
    he: 'שחרר',
    de: 'Entsperren',
    es: 'Desbloquear',
    ru: 'Разблокировать',
    vi: 'Mở khóa',
  },
  cancel: {
    zh_cn: '取消',
    zhhant: '取消',
    en: 'Cancel',
    he: 'ביטול',
    de: 'Abbrechen',
    es: 'Cancelar',
    ru: 'Отменить',
    vi: 'Hủy',
  },
  confirm: {
    zh_cn: '确定',
    zhhant: '確定',
    en: 'Confirm',
    he: 'אישור',
    de: 'Bestätigen',
    es: 'Confirmar',
    ru: 'Подтвердить',
    vi: 'Xác nhận',
  },
  use: {
    zh_cn: '授权',
    zhhant: '授權',
    en: 'Use',
    he: 'השתמש',
    de: 'Verwenden',
    es: 'Usar',
    ru: 'Использовать',
    vi: 'Sử dụng',
  },
  add: {
    zh_cn: '添加',
    zhhant: '添加',
    en: 'Add',
    he: 'הוסף',
    de: 'Hinzufügen',
    es: 'Agregar',
    ru: 'Добавить',
    vi: 'Thêm',
  },
  added: {
    zh_cn: '已添加',
    zhhant: '已添加',
    en: 'Added',
    he: 'נוסף',
    de: 'Hinzugefügt',
    es: 'Añadido',
    ru: 'Добавлено',
    vi: 'Đã thêm',
  },
  update: {
    zh_cn: '更新',
    zhhant: '更新',
    en: 'Update',
    he: 'עדכן',
    de: 'Aktualisieren',
    es: 'Actualizar',
    ru: 'Обновить',
    vi: 'Cập nhật',
  },
  delete: {
    zh_cn: '删除',
    zhhant: '刪除',
    en: 'Delete',
    he: 'מחק',
    de: 'Löschen',
    es: 'Eliminar',
    ru: 'Удалить',
    vi: 'Xóa',
  },
  stop: {
    zh_cn: '停用',
    zhhant: '停用',
    en: 'Stop',
    he: 'עצור',
    de: 'Stoppen',
    es: 'Detener',
    ru: 'Остановить',
    vi: 'Dừng',
  },
  reboot: {
    zh_cn: '重启',
    zhhant: '重启',
    en: 'Reboot',
    he: 'אפס',
    de: 'Neustarten',
    es: 'Reiniciar',
    ru: 'Перезагрузить',
    vi: 'Khởi động lại',
  },
  reset: {
    zh_cn: '重置',
    zhhant: '重置',
    en: 'Reset',
    he: 'אפס',
    de: 'Zurücksetzen',
    es: 'Restablecer',
    ru: 'Сбросить',
    vi: 'Đặt lại',
  },
  confirmOp: {
    zh_cn: '确认执行操作: ',
    zhhant: '確認執行操作: ',
    en: 'Confirm Operation: ',
    he: 'אשר פעולה:',
    de: 'Bestätige Vorgang: ',
    es: 'Confirme la operación: ',
    ru: 'Подтвердить операцию: ',
    vi: 'Xác nhận hoạt động: ',
  },
  confirmSelect: {
    zh_cn: '确认选择: ',
    zhhant: '確認選擇: ',
    en: 'Confirm Selection: ',
    he: 'אשר בחירה:',
    de: 'Bestätige Auswahl: ',
    es: 'Confirme la selección: ',
    ru: 'Подтвердить выбор: ',
    vi: 'Xác nhận lựa chọn: ',
  },
  confirmDelete: {
    zh_cn: '确认删除？',
    zhhant: '確認刪除？',
    en: 'Confirm Delete?',
    he: 'אשר מחיקה?',
    de: 'Löschen bestätigen?',
    es: '¿Confirmar eliminación?',
    ru: 'Подтвердить удаление?',
    vi: 'Xác nhận xóa?',
  },
  retrySuccess: {
    zh_cn: '重试成功',
    zhhant: '重試成功',
    en: 'Retry Successfully',
    he: 'נסה שוב בהצלחה',
    de: 'Erfolgreich wiederholt',
    es: 'Reintentado con éxito',
    ru: 'Повторить успешно',
    vi: 'Thử lại thành công',
  },
  createSuccess: {
    zh_cn: '创建成功',
    zhhant: '創建成功',
    en: 'Created Successfully',
    he: 'נוצר בהצלחה',
    de: 'Erfolgreich erstellt',
    es: 'Creado con éxito',
    ru: 'Создано успешно',
    vi: 'Tạo thành công',
  },
  deleteSuccess: {
    zh_cn: '删除成功',
    zhhant: '刪除成功',
    en: 'Deleted Successfully',
    he: 'נמחק בהצלחה',
    de: 'Erfolgreich gelöscht',
    es: 'Eliminado con éxito',
    ru: 'Удалено успешно',
    vi: 'Xóa thành công',
  },
  updateSuccess: {
    zh_cn: '更新成功',
    zhhant: '更新成功',
    en: 'Updated Successfully',
    he: 'עודכן בהצלחה',
    de: 'Erfolgreich aktualisiert',
    es: 'Actualizado con éxito',
    ru: 'Обновлено успешно',
    vi: 'Cập nhật thành công',
  },
  resetSuccess: {
    zh_cn: '重置成功',
    zhhant: '重置成功',
    en: 'Reset Successfully',
    he: 'אופס בהצלחה',
    de: 'Erfolgreich zurückgesetzt',
    es: 'Restablecido con éxito',
    ru: 'Сброшено успешно',
    vi: 'Đặt lại thành công',
  },
  editSuccess: {
    zh_cn: '编辑成功',
    zhhant: '編輯成功',
    en: 'Edited Successfully',
    he: 'נערך בהצלחה',
    de: 'Erfolgreich bearbeitet',
    es: 'Editado con éxito',
    ru: 'Отредактировано успешно',
    vi: 'Chỉnh sửa thành công',
  },
  useSuccess: {
    zh_cn: '授权成功',
    zhhant: '授權成功',
    en: 'Used Successfully',
    he: 'השתמש בהצלחה',
    de: 'Erfolgreich verwendet',
    es: 'Usado con éxito',
    ru: 'Использовано успешно',
    vi: 'Sử dụng thành công',
  },
  enableSuccess: {
    zh_cn: '启用成功',
    zhhant: '啟用成功',
    en: 'Enabled Successfully',
    he: 'הופעל בהצלחה',
    de: 'Erfolgreich aktiviert',
    es: 'Habilitado con éxito',
    ru: 'Активировано успешно',
    vi: 'Kích hoạt thành công',
  },
  disabledSuccess: {
    zh_cn: '停用成功',
    zhhant: '停用成功',
    en: 'Disabled Successfully',
    he: 'כבוי בהצלחה',
    de: 'Erfolgreich deaktiviert',
    es: 'Deshabilitado con éxito',
    ru: 'Отключено успешно',
    vi: 'Vô hiệu hóa thành công',
  },
  opSuccess: {
    zh_cn: '操作成功',
    zhhant: '操作成功',
    en: 'Operated Successfully',
    he: 'בוצע בהצלחה',
    de: 'Erfolgreich ausgeführt',
    es: 'Operado con éxito',
    ru: 'Выполнено успешно',
    vi: 'Thực hiện thành công',
  },
  collapse: {
    zh_cn: '收起',
    zhhant: '收起',
    en: 'Collapse',
    he: 'צמצם',
    de: 'Einklappen',
    es: 'Colapsar',
    ru: 'Свернуть',
    vi: 'Thu gọn',
  },
  next: {
    zh_cn: '下一页',
    zhhant: '下一頁',
    en: 'Next',
    he: 'הבא',
    de: 'Nächste',
    es: 'Siguiente',
    ru: 'Следующий',
    vi: 'Tiếp theo',
  },
  prev: {
    zh_cn: '上一页',
    zhhant: '上一頁',
    en: 'Previous',
    he: 'הקודם',
    de: 'Zurück',
    es: 'Anterior',
    ru: 'Предыдущий',
    vi: 'Trước',
  },
  day: {
    zh_cn: '天',
    zhhant: '天',
    en: 'Day | Days',
    he: 'יום | ימים',
    de: 'Tag | Tage',
    es: 'día | días',
    ru: 'день | дни',
    vi: 'ngày | ngày',
  },
  month: {
    zh_cn: '月',
    zhhant: '月',
    en: 'Month',
    he: 'חודש',
    de: 'Monat',
    es: 'mes',
    ru: 'месяц',
    vi: 'tháng',
  },
  year: {
    zh_cn: '年',
    zhhant: '年',
    en: 'Year',
    he: 'שנים',
    de: 'Jahre',
    es: 'años',
    ru: 'годы',
    vi: 'năm',
  },
  select: {
    zh_cn: '选择',
    zhhant: '選擇',
    en: 'Select',
    he: 'בחר',
    de: 'Auswählen',
    es: 'Seleccionar',
    ru: 'Выбрать',
    vi: 'Chọn',
  },
  search: {
    zh_cn: '搜索',
    zhhant: '搜尋',
    en: 'Search',
    he: 'חפש',
    de: 'Suche',
    es: 'Buscar',
    ru: 'Поиск',
    vi: 'Tìm kiếm',
  },
  manage: {
    zh_cn: '管理',
    zhhant: '管理',
    en: 'Manage',
    he: 'נהל',
    de: 'Verwalten',
    es: 'Gestionar',
    ru: 'Управлять',
    vi: 'Quản lý',
  },
  tips: {
    zh_cn: '提示',
    zhhant: '提示',
    en: 'Tips',
    he: 'טיפים',
    de: 'Tipps',
    es: 'Consejos',
    ru: 'Советы',
    vi: 'Mẹo',
  },
  operateSuccess: {
    zh_cn: '操作成功',
    zhhant: '操作成功',
    en: 'Operate Successfully',
    he: 'הפעולה בוצעה בהצלחה',
    de: 'Erfolgreich durchgeführt',
    es: 'Operación exitosa',
    ru: 'Операция выполнена успешно',
    vi: 'Thực hiện thành công',
  },
  settelment: {
    zh_cn: '结算',
    zhhant: '結算',
    en: 'Settlement',
    he: 'חיוב',
    de: 'Abrechnung',
    es: 'Cierre',
    ru: 'Оплата',
    vi: 'Thanh toán',
  },
  detail: {
    zh_cn: '详情',
    zhhant: '詳情',
    en: 'Detail',
    he: 'פרטים',
    de: 'Detail',
    es: 'Detalle',
    ru: 'Детали',
    vi: 'Chi tiết',
  },
  all: {
    zh_cn: '全部',
    zhhant: '全部',
    en: 'All',
    he: 'כל',
    de: 'Alle',
    es: 'Todos',
    ru: 'Все',
    vi: 'Tất cả',
  },
  unameRequired: {
    zh_cn: '请填写用户名',
    zhhant: '請填寫用戶名',
    en: 'Username is required',
    he: 'שם משתמש נדרש',
    de: 'Benutzername ist erforderlich',
    es: 'Nombre de usuario requerido',
    ru: 'Имя пользователя обязательно',
    vi: 'Tên người dùng là bắt buộc',
  },
  passwordRequired: {
    zh_cn: '请填写密码',
    zhhant: '請填寫密碼',
    en: 'Password is required',
    he: 'סיסמה נדרשת',
    de: 'Passwort ist erforderlich',
    es: 'Se requiere contraseña',
    ru: 'Пароль обязателен',
    vi: 'Mật khẩu là bắt buộc',
  },
  operation: {
    zh_cn: '操作',
    zhhant: '操作',
    en: 'Actions',
    he: 'פעולות',
    de: 'Aktionen',
    es: 'Acciones',
    ru: 'Операции',
    vi: 'Hành động',
  },
  opErr: {
    zh_cn: '操作失败',
    zhhant: '操作失敗',
    en: 'Operation failed',
    he: 'הפעולה נכשלה',
    de: 'Operation fehlgeschlagen',
    es: 'Operación fallida',
    ru: 'Операция не удалась',
    vi: 'Thao tác thất bại',
  },
  nextStep: {
    zh_cn: '下一步',
    zhhant: '下一步',
    en: 'Next',
    he: 'הבא',
    de: 'Nächster Schritt',
    es: 'Siguiente paso',
    ru: 'Следующий шаг',
    vi: 'Bước tiếp theo',
  },
  backStep: {
    zh_cn: '上一步',
    zhhant: '上一步',
    en: 'Back',
    he: 'חזור',
    de: 'Zurück',
    es: 'Paso anterior',
    ru: 'Назад',
    vi: 'Bước trước',
  },
  other: {
    zh_cn: '其它',
    zhhant: '其他',
    en: 'Other',
    he: 'אחר',
    de: 'Andere',
    es: 'Otro',
    ru: 'Другие',
    vi: 'Khác',
  },
  server: {
    zh_cn: '服务',
    zhhant: '服務',
    en: 'Server',
    he: 'שרת',
    de: 'Server',
    es: 'Servidor',
    ru: 'Сервер',
    vi: 'Máy chủ',
  },
  open: {
    zh_cn: '对外开放',
    zhhant: '對外開放',
    en: 'Is Open',
    he: 'פתוח',
    de: 'Öffentlich',
    es: 'Está abierto',
    ru: 'Открыт',
    vi: 'Mở',
  },
  ban: {
    zh_cn: '是否启用',
    zhhant: '是否啟用',
    en: 'Banned',
    he: 'אסור',
    de: 'Gesperrt',
    es: 'Prohibido',
    ru: 'Заблокирован',
    vi: 'Bị cấm',
  },
  enable: {
    zh_cn: '启用',
    zhhant: '啟用',
    en: 'Enable',
    he: 'הפעל',
    de: 'Aktivieren',
    es: 'Habilitar',
    ru: 'Включить',
    vi: 'Kích hoạt',
  },
  enabled: {
    zh_cn: '启用',
    zhhant: '啟用',
    en: 'Enabled',
    he: 'מופעל',
    de: 'Aktiviert',
    es: 'Habilitado',
    ru: 'Включено',
    vi: 'Đã kích hoạt',
  },
  disable: {
    zh_cn: '停用',
    zhhant: '停用',
    en: 'Disable',
    he: 'השבת',
    de: 'Deaktivieren',
    es: 'Deshabilitar',
    ru: 'Отключить',
    vi: 'Vô hiệu hóa',
  },
  disabled: {
    zh_cn: '停用',
    zhhant: '停用',
    en: 'Disabled',
    he: 'מושבת',
    de: 'Deaktiviert',
    es: 'Deshabilitado',
    ru: 'Отключено',
    vi: 'Đã vô hiệu hóa',
  },
  test: {
    zh_cn: '测试',
    zhhant: '測試',
    en: 'Test',
    he: 'בדיקה',
    de: 'Test',
    es: 'Prueba',
    ru: 'Тест',
    vi: 'Kiểm tra',
  },
  help: {
    zh_cn: '帮助',
    zhhant: '幫助',
    en: 'Help',
    he: 'עזרה',
    de: 'Hilfe',
    es: 'Ayuda',
    ru: 'Помощь',
    vi: 'Trợ giúp',
  },
  selectFile: {
    zh_cn: '选择文件',
    zhhant: '選擇檔案',
    en: 'Select file',
    he: 'בחר קובץ',
    de: 'Datei auswählen',
    es: 'Seleccionar archivo',
    ru: 'Выбрать файл',
    vi: 'Chọn tệp',
  },
  yes: {
    zh_cn: '是',
    zhhant: '是',
    en: 'Yes',
    he: 'כן',
    de: 'Ja',
    es: 'Sí',
    ru: 'Да',
    vi: 'Có',
  },
  no: {
    zh_cn: '否',
    zhhant: '否',
    en: 'No',
    he: 'לא',
    de: 'Nein',
    es: 'No',
    ru: 'Нет',
    vi: 'Không',
  },
  second: {
    zh_cn: '秒 | 秒',
    zhhant: '秒 | 秒',
    en: 'second | seconds',
    he: 'שנייה | שניות',
    de: 'Sekunde | Sekunden',
    es: 'segundo | segundos',
    ru: 'секунда | секунды',
    vi: 'giây | giây',
  },
  minute: {
    zh_cn: '分钟',
    zhhant: '分鐘',
    en: 'minute',
    he: 'דקה',
    de: 'Minute',
    es: 'minuto',
    ru: 'минута',
    vi: 'phút',
  },
  hour: {
    zh_cn: '小时',
    zhhant: '小時',
    en: 'hour',
    he: 'שעה',
    de: 'Stunde',
    es: 'hora',
    ru: 'час',
    vi: 'giờ',
  },
  milliseconds: {
    zh_cn: '毫秒',
    zhhant: '毫秒',
    en: 'milliseconds',
    he: 'מילישניות',
    de: 'Millisekunden',
    es: 'milisegundos',
    ru: 'миллисекунды',
    vi: 'mili giây',
  },
  up: {
    zh_cn: '上移',
    zhhant: '上移',
    en: 'Up',
    he: 'מעלה',
    de: 'Nach oben',
    es: 'Arriba',
    ru: 'Вверх',
    vi: 'Lên',
  },
  down: {
    zh_cn: '下移',
    zhhant: '下移',
    en: 'Down',
    he: 'למטה',
    de: 'Nach unten',
    es: 'Abajo',
    ru: 'Вниз',
    vi: 'Xuống',
  },
  config: {
    zh_cn: '配置',
    zhhant: '設定',
    en: 'Config',
    he: 'הגדרות',
    de: 'Konfiguration',
    es: 'Configuración',
    ru: 'Настройки',
    vi: 'Cấu hình',
  },
  setting: {
    zh_cn: '设置',
    zhhant: '設置',
    en: 'Settings',
    he: 'הגדרות',
    de: 'Einstellungen',
    es: 'Configuraciones',
    ru: 'Настройки',
    vi: 'Cài đặt',
  },
  download: {
    zh_cn: '下载',
    zhhant: '下載',
    en: 'Download',
    he: 'הורד',
    de: 'Herunterladen',
    es: 'Descargar',
    ru: 'Скачать',
    vi: 'Tải xuống',
  },
  more: {
    zh_cn: '更多',
    zhhant: '更多',
    en: 'More',
    he: 'עוד',
    de: 'Mehr',
    es: 'Más',
    ru: 'Больше',
    vi: 'Thêm',
  },
  or: {
    zh_cn: '或',
    zhhant: '或',
    en: 'Or',
    he: 'או',
    de: 'Oder',
    es: 'O',
    ru: 'Или',
    vi: 'Hoặc',
  },
  confirmReplacement: {
    zh_cn: '是否确认替换当前内容？',
    zhhant: '是否確認替換當前內容？',
    en: 'Are you sure you want to replace the current content?',
    he: 'האם אתה בטוח שברצונך להחליף את התוכן הנוכחי?',
    de: 'Möchten Sie den aktuellen Inhalt wirklich ersetzen?',
    es: '¿Está seguro de que desea reemplazar el contenido actual?',
    ru: 'Вы уверены, что хотите заменить текущее содержимое?',
    vi: 'Bạn có chắc chắn muốn thay thế nội dung hiện tại không?',
  },
  import: {
    zh_cn: '导入',
    zhhant: '匯入',
    en: 'Import',
    he: 'ייבא',
    de: 'Importieren',
    es: 'Importar',
    ru: 'Импортировать',
    vi: 'Nhập khẩu',
  },
  downloadTemplate: {
    zh_cn: '下载模板',
    zhhant: '下載模板',
    en: 'Download template',
    he: 'הורד תבנית',
    de: 'Vorlage herunterladen',
    es: 'Descargar plantilla',
    ru: 'Скачать шаблон',
    vi: 'Tải mẫu',
  },
  importSuc: {
    zh_cn: '导入成功',
    zhhant: '匯入成功',
    en: 'Imported Successfully',
    he: 'ייבוא הצליח',
    de: 'Erfolgreich importiert',
    es: 'Importado con éxito',
    ru: 'Успешно импортировано',
    vi: 'Nhập khẩu thành công',
  },
  noData: {
    zh_cn: '暂无数据',
    zhhant: '暫無數據',
    en: 'No data',
    he: 'אין נתונים',
    de: 'Keine Daten',
    es: 'Sin datos',
    ru: 'Нет данных',
    vi: 'Không có dữ liệu',
  },
  extensionErrorMsg: {
    zh_cn: '请上传拓展名为 {extensions} 的文件',
    zhhant: '請上傳擴展名為 {extensions} 的文件',
    en: 'Please upload a file with extension {extensions}',
    he: 'אנא העלה קובץ עם סיומת {extensions}',
    de: 'Bitte laden Sie eine Datei mit der Erweiterung {extensions} hoch',
    es: 'Por favor, sube un archivo con la extensión {extensions}',
    ru: 'Пожалуйста, загрузите файл с расширением {extensions}',
    vi: 'Vui lòng tải lên tệp có phần mở rộng {extensions}',
  },
  connected: {
    zh_cn: '已连接',
    zhhant: '已連接',
    en: 'Connected',
    he: 'מחובר',
    de: 'Verbunden',
    es: 'Conectado',
    ru: 'Подключено',
    vi: 'Đã kết nối',
  },
  disconnected: {
    zh_cn: '已断开',
    zhhant: '已斷開',
    en: 'Disconnected',
    he: 'מנותק',
    de: 'Getrennt',
    es: 'Desconectado',
    ru: 'Отключено',
    vi: 'Đã ngắt kết nối',
  },
  connecting: {
    zh_cn: '连接中',
    zhhant: '連接中',
    en: 'Connecting',
    he: 'מתחבר',
    de: 'Verbindet',
    es: 'Conectando',
    ru: 'Подключение',
    vi: 'Đang kết nối',
  },
  inconsistent: {
    zh_cn: '集群中各节点不一致',
    zhhant: '集群中各節點不一致',
    en: 'Inconsistent for nodes in the cluster',
    he: 'לא עקבי בין הצמתים בקלוסטר',
    de: 'Inkonsistent für Knoten im Cluster',
    es: 'Inconsistente para nodos en el clúster',
    ru: 'Несоответствие между узлами кластера',
    vi: 'Không nhất quán giữa các nút trong cụm',
  },
  stopped: {
    zh_cn: '已停止',
    zhhant: '已停止',
    en: 'Stopped',
    he: 'עצר',
    de: 'Gestoppt',
    es: 'Detenido',
    ru: 'Остановлено',
    vi: 'Đã dừng',
  },
  overview: {
    zh_cn: '概览',
    zhhant: '概覽',
    en: 'Overview',
    he: 'סקירה כללית',
    de: 'Überblick',
    es: 'Resumen',
    ru: 'Обзор',
    vi: 'Tổng quan',
  },
  monitor: {
    zh_cn: '监控',
    zhhant: '監控',
    en: 'Monitor',
    he: 'מעקב',
    de: 'Überwachen',
    es: 'Monitorizar',
    ru: 'Мониторинг',
    vi: 'Giám sát',
  },
  ado: {
    zh_cn: '授权对象',
    zhhant: '授權對象',
    en: 'Auth Use Object',
    he: 'אובייקט שימוש בהרשאות',
    de: 'Auth-Nutzobjekt',
    es: 'Objeto de autorización',
    ru: 'Объект авторизации',
    vi: 'Đối tượng cấp quyền',
  },
  id: {
    zh_cn: 'ID',
    zhhant: 'ID',
    en: 'ID',
    he: 'מזהה',
    de: 'ID',
    es: 'ID',
    ru: 'ID',
    vi: 'ID',
  },
  account: {
    zh_cn: '账号',
    zhhant: '帳號',
    en: 'Account',
    he: 'חשבונית',
    de: 'Konto',
    es: 'Cuenta',
    ru: 'Аккаунт',
    vi: 'Tài khoản',
  },
  passwd: {
    zh_cn: '密码',
    zhhant: '密碼',
    en: 'Password',
    he: 'סיסמה',
    de: 'Passwort',
    es: 'Contraseña',
    ru: 'Пароль',
    vi: 'Mật khẩu',
  },
  nickname: {
    zh_cn: '用户昵称',
    zhhant: '用戶暱稱',
    en: 'Nickname',
    he: 'כינוי',
    de: 'Spitzname',
    es: 'Apodo',
    ru: 'Псевдоним',
    vi: 'Tên người dùng',
  },
  name: {
    zh_cn: '名称',
    zhhant: '名稱',
    en: 'Name',
    he: 'שם',
    de: 'Name',
    es: 'Nombre',
    ru: 'Имя',
    vi: 'Tên',
  },
  desc: {
    zh_cn: '描述',
    zhhant: '描述',
    en: 'Description',
    he: 'תיאור',
    de: 'Beschreibung',
    es: 'Descripción',
    ru: 'Описание',
    vi: 'Mô tả',
  },
  status: {
    zh_cn: '状态',
    zhhant: '狀態',
    en: 'Status',
    he: 'סטטוס',
    de: 'Status',
    es: 'Estado',
    ru: 'Статус',
    vi: 'Trạng thái',
  },
  moveToTop: {
    zh_cn: '移到顶部',
    zhhant: '移到頂部',
    en: 'Move to top',
    he: 'עבור לראש',
    de: 'Nach oben verschieben',
    es: 'Mover al principio',
    ru: 'Переместить наверх',
    vi: 'Di chuyển lên đầu',
  },
  moveToBottom: {
    zh_cn: '移到底部',
    zhhant: '移到底部',
    en: 'Move to bottom',
    he: 'עבור לתחתית',
    de: 'Nach unten verschieben',
    es: 'Mover al final',
    ru: 'Переместить вниз',
    vi: 'Di chuyển xuống dưới cùng',
  },
  refresh: {
    zh_cn: '刷新',
    zhhant: '刷新',
    en: 'Refresh',
    he: 'רענן',
    de: 'Aktualisieren',
    es: 'Actualizar',
    ru: 'Обновить',
    vi: 'Làm mới',
  },
  balance: {
    zh_cn: '余额',
    zhhant: '餘額',
    en: 'Balance',
    he: 'מטבע',
    de: 'Guthaben',
    es: 'Equilibrio',
    ru: 'Баланс',
    vi: 'Số dư',
  },
  gift: {
    zh_cn: '赠送',
    zhhant: '贈送',
    en: 'Gift',
    he: 'תנו',
    de: 'Geschenk',
    es: 'Regalo',
    ru: 'Подарок',
    vi: 'Quà tặng',
  },
  recharge: {
    zh_cn: '充值',
    zhhant: '充值',
    en: 'Recharge',
    he: 'רכיב',
    de: 'Aufladen',
    es: 'Recargar',
    ru: 'Пополнить',
    vi: 'Nạp lại',
  },
  rechargeInquiry: {
    zh_cn: '充值扣款',
    zhhant: '充值扣款',
    en: 'Recharge Deduction',
    he: 'חיוב טעינה',
    de: 'Aufladeabzug',
    es: 'Deducción de recarga',
    ru: 'Списание за пополнение',
    vi: 'Khấu trừ nạp tiền',
  },
  refund: {
    zh_cn: '退款',
    zhhant: '退款',
    en: 'Refund',
    he: 'חזר',
    de: 'Rückgabe',
    es: 'Reembolso',
    ru: 'Возврат',
    vi: 'Hoàn tiền',
  },
  withhold: {
    zh_cn: '扣款',
    zhhant: '扣款',
    en: 'Withhold',
    he: 'קבלה',
    de: 'Abziehen',
    es: 'Retención',
    ru: 'Списание',
    vi: 'Khấu trừ',
  },
  consumption: {
    zh_cn: '消费',
    zhhant: '消費',
    en: 'Consumption',
    he: 'משאבי',
    de: 'Verbrauch',
    es: 'Consumo',
    ru: 'Потребление',
    vi: 'Sử dụng',
  },
  chargingOrder: {
    zh_cn: '充电单',
    zhhant: '充電單',
    en: 'Charging Order',
    he: 'מספר הזמנה',
    de: 'Ladebestellung',
    es: 'Pedido de carga',
    ru: 'Замена',
    vi: 'Đơn đặt hàng',
  },
  occupancyOrder: {
    zh_cn: '占桩单',
    zhhant: '佔桩單',
    en: 'Occupancy Order',
    he: 'מספר הזמנה',
    de: 'Nutzungsauftrag',
    es: 'Pedido de ocupación',
    ru: 'Замена',
    vi: 'Đơn đặt hàng',
  },
  remark: {
    zh_cn: '备注',
    zhhant: '備註',
    en: 'Remark',
    he: 'הערות',
    de: 'Bemerkung',
    es: 'Nota',
    ru: 'Примечание',
    vi: 'Chú thích',
  },
  current: {
    zh_cn: '当前值',
    zhhant: '當前值',
    en: 'Current',
    he: 'נוכחי',
    de: 'Aktuell',
    es: 'Actual',
    ru: 'Текущий',
    vi: 'Hiện tại',
  },
  highWatermark: {
    zh_cn: '高水位线',
    zhhant: '高水位線',
    en: 'High Watermark',
    he: 'קו מים גבוה',
    de: 'Höchstwert',
    es: 'Marca máxima',
    ru: 'Максимальный уровень',
    vi: 'Mức nước cao',
  },
  max: {
    zh_cn: '最大值',
    zhhant: '最大值',
    en: 'Maximum',
    he: 'מקסימום',
    de: 'Maximum',
    es: 'Máximo',
    ru: 'Максимум',
    vi: 'Tối đa',
  },
  removeSuccess: {
    zh_cn: '移除成功',
    zhhant: '移除成功',
    en: 'Removed Successfully',
    he: 'הוסר בהצלחה',
    de: 'Erfolgreich entfernt',
    es: 'Eliminado con éxito',
    ru: 'Успешно удалено',
    vi: 'Xóa thành công',
  },
  type: {
    zh_cn: '类型',
    zhhant: '類型',
    en: 'Type',
    he: 'סוג',
    de: 'Art',
    es: 'Tipo',
    ru: 'Тип',
    vi: 'Loại',
  },
  remove: {
    zh_cn: '移除',
    zhhant: '移除',
    en: 'Remove',
    he: 'הסר',
    de: 'Entfernen',
    es: 'Eliminar',
    ru: 'Удалить',
    vi: 'Xóa',
  },
  filePath: {
    zh_cn: '文件路径',
    zhhant: '文件路徑',
    en: 'File path',
    he: 'נתיב קובץ',
    de: 'Dateipfad',
    es: 'Ruta del archivo',
    ru: 'Путь к файлу',
    vi: 'Đường dẫn tệp',
  },
  address: {
    zh_cn: '地址',
    zhhant: '地址',
    en: 'Address',
    he: 'כתובת',
    de: 'Adresse',
    es: 'Dirección',
    ru: 'Адрес',
    vi: 'Địa chỉ',
  },
  resetConfig: {
    zh_cn: '重新设置',
    zhhant: '重新設置',
    en: 'Reset',
    he: 'אפס',
    de: 'Zurücksetzen',
    es: 'Restablecer',
    ru: 'Сбросить',
    vi: 'Đặt lại',
  },
  banned: {
    zh_cn: '禁用',
    zhhant: '禁用',
    en: 'Banned',
    he: 'חסום',
    de: 'Gesperrt',
    es: 'Prohibido',
    ru: 'Запрещено',
    vi: 'Bị cấm',
  },
  isEnabled: {
    zh_cn: '启用',
    zhhant: '啟用',
    en: 'Enable',
    he: 'אפשר',
    de: 'Aktivieren',
    es: 'Habilitar',
    ru: 'Включить',
    vi: 'Kích hoạt',
  },
  rate: {
    zh_cn: '速率',
    zhhant: '速率',
    en: 'Rate',
    he: 'קצב',
    de: 'Rate',
    es: 'Tasa',
    ru: 'Скорость',
    vi: 'Tốc độ',
  },
  topic: {
    zh_cn: '主题',
    zhhant: '主題',
    en: 'Topic',
    he: 'נושא',
    de: 'Thema',
    es: 'Tema',
    ru: 'Тема',
    vi: 'Chủ đề',
  },
  default: {
    zh_cn: '默认',
    zhhant: '預設',
    en: 'Default',
    he: 'ברירת מחדל',
    de: 'Standard',
    es: 'Predeterminado',
    ru: 'По умолчанию',
    vi: 'Mặc định',
  },
  defaultPwdTip: {
    zh_cn: '为保护账户安全，请修改默认密码：',
    zhhant: '為保護帳戶安全，請修改預設密碼：',
    en: 'To ensure your account security, we kindly request you to change your default password:',
    he: 'כדי להבטיח את אבטחת החשבון שלך, אנו מבקשים ממך לשנות את הסיסמה ברירת המחדל שלך:',
    de: 'Um die Sicherheit Ihres Kontos zu gewährleisten, bitten wir Sie, Ihr Standardpasswort zu ändern:',
    es: 'Para garantizar la seguridad de su cuenta, le solicitamos que cambie su contraseña predeterminada:',
    ru: 'Для обеспечения безопасности вашей учетной записи, пожалуйста, измените ваш пароль по умолчанию:',
    vi: 'Để đảm bảo an ninh tài khoản của bạn, chúng tôi yêu cầu bạn thay đổi mật khẩu mặc định của mình:',
  },
  note: {
    zh_cn: '备注',
    zhhant: '備註',
    en: 'Note',
    he: 'הערה',
    de: 'Hinweis',
    es: 'Nota',
    ru: 'Примечание',
    vi: 'Ghi chú',
  },
  documentation: {
    zh_cn: '文档',
    zhhant: '文件',
    en: 'Documentation',
    he: 'תיעוד',
    de: 'Dokumentation',
    es: 'Documentación',
    ru: 'Документация',
    vi: 'Tài liệu',
  },
  tokenExpiredMsg: {
    zh_cn: '登录过期，请重新登录',
    zhhant: '登入過期，請重新登入',
    en: 'Login has expired, please login again',
    he: 'ההתחברות פגה, אנא התחבר שוב',
    de: 'Anmeldung abgelaufen, bitte erneut anmelden',
    es: 'La sesión ha expirado, por favor inicie sesión nuevamente',
    ru: 'Сессия истекла, пожалуйста, войдите снова',
    vi: 'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại',
  },
  deletedAccount: {
    zh_cn: '已删除账号',
    zhhant: '已刪除帳號',
    en: 'Account has been deleted',
    he: 'חשבון נמחק',
    de: 'Konto gelöscht',
    es: 'Cuenta eliminada',
    ru: 'Учетная запись была удалена',
    vi: 'Tài khoản đã bị xóa',
  },
  sync: {
    zh_cn: '同步',
    zhhant: '同步',
    en: 'Sync',
    he: 'סנכרן',
    de: 'Synchronisieren',
    es: 'Sincronizar',
    ru: 'Синхронизация',
    vi: 'Đồng bộ',
  },
  cache: {
    zh_cn: '缓存',
    zhhant: '緩存',
    en: 'Cache',
    he: 'מטמון',
    de: 'Zwischenspeicher',
    es: 'Caché',
    ru: 'Кэш',
    vi: 'Bộ nhớ cache',
  },
  ip: {
    zh_cn: 'IP 地址',
    zhhant: 'IP 地址',
    en: 'IP Address',
    he: 'כתובת IP',
    de: 'IP-Adresse',
    es: 'Dirección IP',
    ru: 'IP-адрес',
    vi: 'Địa chỉ IP',
  },
  notFound: {
    zh_cn: '未找到页面',
    zhhant: '未找到頁面',
    en: 'This page could not be found',
    he: 'לא נמצא העמוד',
    de: 'Diese Seite konnte nicht gefunden werden',
    es: 'No se pudo encontrar la página',
    ru: 'Страница не найдена',
    vi: 'Không tìm thấy trang',
  },
  pageNotFound: {
    zh_cn: '页面不存在',
    zhhant: '頁面不存在',
    en: 'Not Found',
    he: 'לא נמצא',
    de: 'Nicht gefunden',
    es: 'No encontrado',
    ru: 'Не найдено',
    vi: 'Không tìm thấy',
  },
  leave: {
    zh_cn: '离开',
    zhhant: '離開',
    en: 'Leave',
    he: 'עזוב',
    de: 'Verlassen',
    es: 'Salir',
    ru: 'Покинуть',
    vi: 'Rời khỏi',
  },
  unloadTip: {
    zh_cn: '修改可能不会被保存',
    zhhant: '修改可能不會被保存',
    en: 'Changes that you made may not be saved',
    he: 'השינויים שביצעת עשויים שלא להישמר',
    de: 'Änderungen, die Sie vorgenommen haben, werden möglicherweise nicht gespeichert',
    es: 'Es posible que los cambios que realizó no se guarden',
    ru: 'Внесенные изменения могут не сохраниться',
    vi: 'Những thay đổi bạn thực hiện có thể không được lưu',
  },
  leavePage: {
    zh_cn: '离开页面？',
    zhhant: '離開頁面？',
    en: 'Leave page?',
    he: 'לעזוב את הדף?',
    de: 'Seite verlassen?',
    es: '¿Salir de la página?',
    ru: 'Покинуть страницу?',
    vi: 'Rời khỏi trang?',
  },
  upgrade: {
    zh_cn: '升级',
    zhhant: '升級',
    en: 'Upgrade',
    he: 'שדרוג',
    de: 'Upgrade',
    es: 'Actualizar',
    ru: 'Обновление',
    vi: 'Cập nhật',
  },
  inputWithUploaderTip: {
    zh_cn: '可输入文件内容或点击右侧按钮选择文件',
    zhhant: '可輸入文件內容或點擊右側按鈕選擇文件',
    en: 'You can enter the content of the file or select file by clicking the button on the right',
    he: 'אתה יכול להכניס את תוכן הקובץ או לבחור קובץ על ידי לחיצה על הכפתור справа',
    de: 'Sie können den Inhalt der Datei eingeben oder eine Datei auswählen, indem Sie auf die Schaltfläche rechts klicken',
    es: 'Puedes ingresar el contenido del archivo o seleccionar un archivo haciendo clic en el botón a la derecha',
    ru: 'Вы можете ввести содержимое файла или выбрать файл, нажав на кнопку справа',
    vi: 'Bạn có thể nhập nội dung của tệp hoặc chọn tệp bằng cách nhấp vào nút bên phải',
  },
  uploadTip: {
    zh_cn: '请上传 {format} 文件',
    zhhant: '請上傳 {format} 文件',
    en: 'Please upload a {format} file',
    he: 'אנא העלה קובץ בפורמט {format}',
    de: 'Bitte laden Sie eine {format}-Datei hoch',
    es: 'Por favor, sube un archivo {format}',
    ru: 'Пожалуйста, загрузите файл формата {format}',
    vi: 'Vui lòng tải lên tệp {format}',
  },
  namePwdError: {
    zh_cn: '用户名或密码错误',
    zhhant: '用戶名或密碼錯誤',
    en: 'Incorrect username or password',
    he: 'שם המשתמש או הסיסמה שגויים',
    de: 'Falscher Benutzername oder Passwort',
    es: 'Nombre de usuario o contraseña incorrectos',
    ru: 'Неверное имя пользователя или пароль',
    vi: 'Tên người dùng hoặc mật khẩu không đúng',
  },
  networkError: {
    zh_cn: '网络错误',
    zhhant: '網絡錯誤',
    en: 'Network Error',
    he: 'שגיאת רשת',
    de: 'Netzwerkfehler',
    es: 'Error de red',
    ru: 'Сетевая ошибка',
    vi: 'Lỗi mạng',
  },
  commonIdError: {
    zh_cn: '以字母或数字开头，后续仅限字母、数字、-、_',
    zhhant: '以字母或數字開頭，後續僅限字母、數字、-、_',
    en: 'Start with letter/number; only letters, numbers, -, _ afterwards',
    he: 'מתחיל באות/מספר; רק אותיות, מספרים, -, _ לאחר מכן',
    de: 'Beginnen Sie mit Buchstaben/Ziffern; danach nur Buchstaben, Zahlen, -, _',
    es: 'Empieza con letra/número; solo letras, números, -, _ después',
    ru: 'Начинается с буквы/цифры; далее только буквы, цифры, -, _',
    vi: 'Bắt đầu bằng chữ cái/số; chỉ chữ cái, số, -, _ sau đó',
  },
  letterBeginError: {
    zh_cn: '以字母开头，后续仅限字母、数字、-、_',
    zhhant: '以字母開頭，後續僅限字母、數字、-、_',
    en: 'Start with letter; only letters, numbers, -, _ afterwards',
    he: 'מתחיל באות; רק אותיות, מספרים, -, _ לאחר מכן',
    de: 'Beginnen Sie mit Buchstaben; danach nur Buchstaben, Zahlen, -, _',
    es: 'Empieza con letra; solo letras, números, -, _ después',
    ru: 'Начинается с буквы; далее только буквы, цифры, -, _',
    vi: 'Bắt đầu bằng chữ cái; chỉ chữ cái, số, -, _ sau đó',
  },
  notSupported: {
    zh_cn: '不支持',
    zhhant: '不支援',
    en: 'Not support',
    he: 'לא נתמך',
    de: 'Nicht unterstützt',
    es: 'No soportado',
    ru: 'Не поддерживается',
    vi: 'Không hỗ trợ',
  },
  notSupportedChinese: {
    zh_cn: '不支持中文',
    zhhant: '不支援中文',
    en: 'Does not support Chinese characters',
    he: 'לא תומך בתווים סיניים',
    de: 'Chinesische Zeichen werden nicht unterstützt',
    es: 'No soporta caracteres chinos',
    ru: 'Не поддерживает китайские символы',
    vi: 'Không hỗ trợ ký tự Trung Quốc',
  },
  notSupportedSwicthLoction: {
    zh_cn: '不支持中文',
    zhhant: '不支援中文',
    en: 'Does not support Chinese characters',
    he: 'לא תומך בתווים סיניים',
    de: 'Chinesische Zeichen werden nicht unterstützt',
    es: 'No soporta caracteres chinos',
    ru: 'Не поддерживает китайские символы',
    vi: 'Không hỗ trợ ký tự Trung Quốc',
  },
  showMore: {
    zh_cn: '显示更多',
    zhhant: '顯示更多',
    en: 'Show More',
    he: 'הצג עוד',
    de: 'Mehr anzeigen',
    es: 'Mostrar más',
    ru: 'Показать больше',
    vi: 'Hiển thị thêm',
  },
  lessMore: {
    zh_cn: '收起',
    zhhant: '收起',
    en: 'Less',
    he: 'פחות',
    de: 'Weniger',
    es: 'Menos',
    ru: 'Меньше',
    vi: 'Ít hơn',
  },
  followUs: {
    zh_cn: '关注我们',
    zhhant: '關注我們',
    en: 'Follow Us',
    he: 'עקוב אחרינו',
    de: 'Folgen Sie uns',
    es: 'Síguenos',
    ru: 'Подписаться на нас',
    vi: 'Theo dõi chúng tôi',
  },
  contactUs: {
    zh_cn: '联系我们',
    zhhant: '聯繫我們',
    en: 'Contact Us',
    he: 'צור קשר',
    de: 'Kontaktiere uns',
    es: 'Contáctanos',
    ru: 'Связаться с нами',
    vi: 'Liên hệ với chúng tôi',
  },
  feedback: {
    zh_cn: '反馈',
    zhhant: '反饋',
    en: 'Feedback',
    he: 'משוב',
    de: 'Feedback',
    es: 'Comentarios',
    ru: 'Обратная связь',
    vi: 'Phản hồi',
  },
  none: {
    zh_cn: '无',
    zhhant: '無',
    en: 'None',
    he: 'אין',
    de: 'Keine',
    es: 'Ninguno',
    ru: 'Нет',
    vi: 'Không có',
  },
  retry: {
    zh_cn: '重试',
    en: 'Retry',
    zhhant: '重試',
    he: 'נסה שוב',
    de: 'Erneut versuchen',
    es: 'Reintentar',
    ru: 'Повторить',
    vi: 'Thử Lại',
  },
  total: {
    zh_cn: '总数',
    zhhant: '總數',
    en: 'Total',
    he: 'סך הכל',
    de: 'Gesamt',
    es: 'Total',
    ru: 'Всего',
    vi: 'Tổng số',
  },
  success: {
    zh_cn: '成功',
    zhhant: '成功',
    en: 'Success',
    he: 'הצלחה',
    de: 'Erfolg',
    es: 'Éxito',
    ru: 'Успех',
    vi: 'Thành công',
  },
  failed: {
    zh_cn: '失败',
    zhhant: '失敗',
    en: 'Failed',
    he: 'נכשל',
    de: 'Fehlgeschlagen',
    es: 'Fallido',
    ru: 'Неудача',
    vi: 'Thất bại',
  },
  allow: {
    zh_cn: '允许',
    zhhant: '允許',
    en: 'Allow',
    he: 'אפשר',
    de: 'Erlauben',
    es: 'Permitir',
    ru: 'Разрешить',
    vi: 'Cho phép',
  },

  deny: {
    zh_cn: '拒绝',
    zhhant: '拒絕',
    en: 'Deny',
    he: 'סרב',
    de: 'Ablehnen',
    es: 'Denegar',
    ru: 'Отклонить',
    vi: 'Từ chối',
  },
  nomatch: {
    zh_cn: '不匹配',
    zhhant: '不匹配',
    en: 'No match',
    he: 'לא תואם',
    de: 'Keine Übereinstimmung',
    es: 'No coincide',
    ru: 'Не соответствует',
    vi: 'Không khớp',
  },
  batchSetting: {
    zh_cn: '批量设置',
    zhhant: '批量設置',
    en: 'Batch Setting',
    he: 'הגדרת אצווה',
    de: 'Batch-Einstellung',
    es: 'Configuración por lotes',
    ru: 'Пакетные настройки',
    vi: 'Cài đặt hàng loạt',
  },
  importBatchSetting: {
    zh_cn: '导入批量设置',
    zhhant: '匯入批量設定',
    en: 'Import Batch Setting',
    he: 'ייבוא הגדרת אצווה',
    de: 'Batch-Einstellungen importieren',
    es: 'Importar configuración por lotes',
    ru: 'Импорт пакетных настроек',
    vi: 'Nhập cài đặt hàng loạt',
  },
  downloadTemplatePrompt: {
    zh_cn: '为保证设置顺利，请您下载设置导入模板',
    zhhant: '為保證設置順利，請您下載設置匯入模板',
    en: 'To ensure smooth settings, please download the settings import template',
    he: 'כדי להבטיח הגדרה חלקה, אנא הורד את תבנית ייבוא ההגדרות',
    de: 'Um einen reibungslosen Ablauf der Einstellungen zu gewährleisten, laden Sie bitte die Importvorlage herunter',
    es: 'Para garantizar una configuración sin problemas, por favor descargue la plantilla de importación de configuraciones',
    ru: 'Для обеспечения бесперебойной настройки, пожалуйста, скачайте шаблон импорта настроек',
    vi: 'Để đảm bảo cài đặt suôn sẻ, vui lòng tải xuống mẫu nhập cài đặt',
  },
  batchSettingDownloadFirst: {
    zh_cn: '批量设置需先下载导入模版',
    zhhant: '批量設定需先下載匯入模板',
    en: 'Batch setting requires downloading the import template first',
    he: 'הגדרת אצווה דורשת הורדת תבנית הייבוא קודם',
    de: 'Batch-Einstellungen erfordern zuerst den Download der Importvorlage',
    es: 'La configuración por lotes requiere descargar primero la plantilla de importación',
    ru: 'Для пакетной настройки необходимо сначала скачать шаблон импорта',
    vi: 'Cài đặt hàng loạt yêu cầu tải xuống mẫu nhập trước',
  },
  moreImportInstructions: {
    zh_cn: '更多导入说明和示例，请查看{link}',
    zhhant: '更多匯入說明和示例，請查看{link}',
    en: 'For more import instructions and examples, please check the {link}',
    he: 'ליותר הוראות ייבוא ודוגמאות, אנא בדוק את {link}',
    de: 'Für weitere Importanweisungen und Beispiele überprüfen Sie bitte den {link}',
    es: 'Para más instrucciones y ejemplos de importación, por favor consulte el {link}',
    ru: 'Для получения дополнительных инструкций по импорту и примеров, пожалуйста, проверьте {link}',
    vi: 'Để biết thêm hướng dẫn và ví dụ về nhập, vui lòng kiểm tra {link}',
  },
  helpDocs: {
    zh_cn: '帮助文档',
    zhhant: '幫助文檔',
    en: 'Help documentation',
    he: 'תיעוד עזרה',
    de: 'Hilfe-Dokumentation',
    es: 'Documentación de ayuda',
    ru: 'Документация по помощи',
    vi: 'Tài liệu hướng dẫn',
  },
  uploadFile: {
    zh_cn: '上传文件',
    zhhant: '上傳文件',
    en: 'Upload File',
    he: 'העלה קובץ',
    de: 'Datei hochladen',
    es: 'Subir archivo',
    ru: 'Загрузить файл',
    vi: 'Tải tệp lên',
  },
  csvFileLimit: {
    zh_cn: '支持 csv 格式文件，文件中数据不能超过 2048 行',
    zhhant: '支援 csv 格式文件，文件中數據不能超過 2048 行',
    en: 'Supports csv format files, and the data in the file cannot exceed 2048 lines',
    he: 'תומך בקבצי פורמט csv, והנתונים בקובץ אינם יכולים לחרוג מ-2048 שורות',
    de: 'Unterstützt csv-Formatdateien, und die Daten in der Datei dürfen 2048 Zeilen nicht überschreiten',
    es: 'Soporta archivos en formato csv y los datos en el archivo no pueden exceder las 2048 líneas',
    ru: 'Поддерживаются файлы формата csv, данные в файле не могут превышать 2048 строк',
    vi: 'Hỗ trợ các tệp định dạng csv, và dữ liệu trong tệp không được vượt quá 2048 dòng',
  },
  enterToCreate: {
    zh_cn: '输入后创建新的自定义条目',
    zhhant: '輸入後創建新的自訂條目',
    en: 'Enter to create a new custom item',
    he: 'הכנס כדי ליצור פריט מותאם אישית חדש',
    de: 'Eingeben, um ein neues benutzerdefiniertes Element zu erstellen',
    es: 'Ingrese para crear un nuevo elemento personalizado',
    ru: 'Введите, чтобы создать новый пользовательский элемент',
    vi: 'Nhập để tạo mục tùy chỉnh mới',
  },
  node: {
    zh_cn: '节点',
    zhhant: '節點',
    en: 'Node',
    he: 'צומת',
    de: 'Knoten',
    es: 'Nodo',
    ru: 'Узел',
    vi: 'Nút',
  },
  quickFind: {
    zh_cn: '快速查找',
    zhhant: '快速查找',
    en: 'Quick Find',
    he: 'חיפוש מהיר',
    de: 'Schnellsuche',
    es: 'Búsqueda rápida',
    ru: 'Быстрый поиск',
    vi: 'Tìm kiếm nhanh',
  },
  maxBatchCsvSize: {
    zh_cn: '文件大小不能超过 {size}MB',
    zhhant: '文件大小不能超過 {size}MB',
    en: 'File size cannot exceed {size}MB',
    he: 'גודל הקובץ לא יכול לחרוג מ-{size}MB',
    de: 'Dateigröße darf {size}MB nicht überschreiten',
    es: 'El tamaño del archivo no puede exceder los {size}MB',
    ru: 'Размер файла не может превышать {size}MB',
    vi: 'Kích thước tệp không được vượt quá {size}MB',
  },
  maxBatchInvoiceSize: {
    zh_cn: '文件大小不能超过 500 KB',
    zhhant: '文件大小不能超過 500 KB',
    en: 'File size cannot exceed 500 KB',
    he: 'גודל הקובץ לא יכול לחרוג מ-500 קב',
    de: 'Dateigröße darf 500 KB nicht überschreiten',
    es: 'El tamaño del archivo no puede exceder los 500 KB',
    ru: 'Размер файла не может превышать 500 КБ',
    vi: 'Kích thước tệp không được vượt quá 500 KB',
  },
  openSourceEdition: {
    zh_cn: 'Open Source',
    zhhant: '開源版',
    en: 'Open Source',
    he: 'קוד פתוח',
    de: 'Open Source',
    es: 'Código abierto',
    ru: 'Открытый исходный код',
    vi: 'Mã nguồn mở',
  },
  enterpriseEdition: {
    zh_cn: 'Enterprise',
    zhhant: '企業版',
    en: 'Enterprise',
    he: 'גרסת Enterprise',
    de: 'Enterprise',
    es: 'Empresa',
    ru: 'Предприятие',
    vi: 'Doanh nghiệp',
  },
  regtime: {
    zh_cn: '创建时间',
    zhhant: '創建時間',
    en: 'Register Time',
    he: 'זמן רישום',
    de: 'Registrierungszeit',
    es: 'Hora de registro',
    ru: 'Время регистрации',
    vi: 'Thời gian đăng ký',
  },
  rangeTime: {
    zh_cn: '起止时间',
    zhhant: '起止時間',
    en: 'Range Time',
    he: 'טווח זמן',
    de: 'Zeitbereich',
    es: 'Rango de tiempo',
    ru: 'Диапазон времени',
    vi: 'Khoảng thời gian',
  },
  rangeTimeFilter: {
    zh_cn: '时间范围',
    zhhant: '時間範圍',
    en: 'Range Time',
    he: 'טווח זמן',
    de: 'Zeitbereich',
    es: 'Rango de tiempo',
    ru: 'Диапазон времени',
    vi: 'Khoảng thời gian',
  },
  rangeTimeFilterPlaceholder: {
    zh_cn: '请选择时间范围',
    zhhant: '請選擇時間範圍',
    en: 'Please select a time range',
    he: 'אנא בחר טווח זמן',
    de: 'Bitte einen Zeitbereich auswählen',
    es: 'Por favor, seleccione un rango de tiempo',
    ru: 'Пожалуйста, выберите временной диапазон',
  },
  beginTime: {
    zh_cn: '开始时间',
    zhhant: '開始時間',
    en: 'Begin Time',
    he: 'זמן התחלה',
    de: 'Beginnzeit',
    es: 'Hora de inicio',
    ru: 'Время начала',
    vi: 'Thời gian bắt đầu',
  },
  endTime: {
    zh_cn: '结束时间',
    zhhant: '結束時間',
    en: 'End Time',
    he: 'זמן סיום',
    de: 'Endzeit',
    es: 'Hora de finalización',
    ru: 'Время окончания',
    vi: 'Thời gian kết thúc',
  },
  gte: {
    zh_cn: '在此之后',
    zhhant: '在此之後',
    en: 'After',
    he: 'אחריו',
    de: 'Nach',
    es: 'Después',
    ru: 'После',
    vi: 'Sau',
  },
  lte: {
    zh_cn: '在此之前',
    zhhant: '在此之前',
    en: 'Before',
    he: 'לפני',
    de: 'Vor',
    es: 'Antes',
    ru: 'До',
    vi: 'Trước',
  },
  loginTitle: {
    zh_cn: '充电运营系统',
    zhhant: '充電運營系統',
    en: 'EV Charging',
    he: 'מערכת טעינת רכבים חשמליים',
    de: 'EV-Ladung',
    es: 'Carga de EV',
    ru: 'Зарядка EV',
    vi: 'Sạc EV',
  },

  timeLastDay: {
    zh_cn: '最近一天',
    zhhant: '最近一天',
    en: 'Last Day',
    he: 'יום אחרון',
    de: 'Letzter Tag',
    es: 'Último día',
    ru: 'Последний день',
    vi: 'Ngày cuối',
  },
  timeLastWeek: {
    zh_cn: '最近一周',
    zhhant: '最近一周',
    en: 'Last Week',
    he: 'שבוע אחרון',
    de: 'Letzte Woche',
    es: 'Última semana',
    ru: 'Последняя неделя',
    vi: 'Tuần trước',
  },
  timeLastMonth: {
    zh_cn: '最近一月',
    zhhant: '最近一個月',
    en: 'Last Month',
    he: 'חודש אחרון',
    de: 'Letzter Monat',
    es: 'Último mes',
    ru: 'Последний месяц',
    vi: 'Tháng trước',
  },
  timeLastYear: {
    zh_cn: '最近一年',
    zhhant: '最近一年',
    en: 'Last Year',
    he: 'שנה אחרונה',
    de: 'Letztes Jahr',
    es: 'Último año',
    ru: 'Последний год',
    vi: 'Năm ngoái',
  },
  notSupport: {
    zh_cn: '暂时不支持, 敬请期待!!!',
    zhhant: '暫時不支援，敬請期待!!!',
    en: 'Temporarily not supported, please look forward to!!!',
    he: 'לא נתמך כרגע, אנא המתן!!!',
    de: 'Derzeit nicht unterstützt, bitte warten Sie!!!',
    es: 'No soportado temporalmente, ¡por favor espere!',
    ru: 'Временно не поддерживается, пожалуйста, ждите!!!',
    vi: 'Tạm thời không hỗ trợ, vui lòng chờ đợi!!!',
  },
  unknown: {
    zh_cn: '未知',
    zhhant: '未知',
    en: 'Unknown',
    he: 'לא ידוע',
    de: 'Unbekannt',
    es: 'Desconocido',
    ru: 'Неизвестно',
    vi: 'Không xác định',
  },
  stateInit: {
    zh_cn: '初始状态',
    zhhant: '初始狀態',
    en: 'Initial State',
    he: 'מצב ראשוני',
    de: 'Anfangszustand',
    es: 'Estado inicial',
    ru: 'Начальное состояние',
    vi: 'Trạng thái khởi tạo',
  },
  stateWait: {
    zh_cn: '待处理',
    zhhant: '待處理',
    en: 'Pending',
    he: 'ממתין',
    de: 'Ausstehend',
    es: 'Pendiente',
    ru: 'Ожидание',
    vi: 'Đang chờ',
  },
  stateProcess: {
    zh_cn: '处理中',
    zhhant: '處理中',
    en: 'Process',
    he: 'בתהליך',
    de: 'Verarbeitung',
    es: 'En proceso',
    ru: 'В процессе',
    vi: 'Đang xử lý',
  },
  abnormal: {
    zh_cn: '异常',
    zhhant: '異常',
    en: 'Abnormal',
    he: 'לא מוצלח',
    de: 'Abnormal',
    es: 'Anormal',
    ru: 'Ненормально',
    vi: 'Bất thường',
  },
  stateAbnormal: {
    zh_cn: '异常状态',
    zhhant: '異常狀態',
    en: 'Abnormal State',
    he: 'מצב לא מוצלח',
    de: 'Abnormaler Zustand',
    es: 'Estado anormal',
    ru: 'Необычное состояние',
    vi: 'Trạng thái bất thường',
  },
  stateClose: {
    zh_cn: '关闭',
    zhhant: '關閉',
    en: 'Close',
    he: 'סגור',
    de: 'Hängen',
    es: 'Colgar',
    ru: 'Приостановлено',
    vi: 'Tạm dừng',
  },
  stateFinish: {
    zh_cn: '完成',
    zhhant: '完成',
    en: 'Finish',
    he: 'הושלם',
    de: 'Verarbeitet',
    es: 'Procesado',
    ru: 'Обработано',
    vi: 'Đã xử lý',
  },

  init: {
    zh_cn: '初始状态',
    zhhant: '初始狀態',
    en: 'Initialization',
    he: 'הגדרה ראשונית',
    de: 'Initialisierung',
    es: 'Inicialización',
    ru: 'Инициализация',
    vi: 'Khởi tạo',
  },
  pending: {
    zh_cn: '待处理',
    zhhant: '待處理',
    en: 'Pending',
    he: 'ממתין',
    de: 'Ausstehend',
    es: 'Pendiente',
    ru: 'Ожидание',
    vi: 'Đang chờ',
  },
  process: {
    zh_cn: '处理中',
    zhhant: '處理中',
    en: 'Process',
    he: 'בתהליך',
    de: 'Verarbeitung',
    es: 'En proceso',
    ru: 'В процессе',
    vi: 'Đang xử lý',
  },
  hangup: {
    zh_cn: '挂起',
    zhhant: '掛起',
    en: 'Hangup',
    he: 'נתק',
    de: 'Hängen',
    es: 'Colgar',
    ru: 'Приостановлено',
    vi: 'Tạm dừng',
  },
  processed: {
    zh_cn: '已经处理完成',
    zhhant: '已經處理完成',
    en: 'Processed',
    he: 'הושלם',
    de: 'Verarbeitet',
    es: 'Procesado',
    ru: 'Обработано',
    vi: 'Đã xử lý',
  },
  close: {
    zh_cn: '关闭',
    zhhant: '關閉',
    en: 'Close',
    he: 'סגור',
    de: 'Schließen',
    es: 'Cerrar',
    ru: 'Закрыть',
    vi: 'Đóng',
  },
  q: {
    zh_cn: '疑问',
    zhhant: '疑問',
    en: 'Question',
    he: 'שאלה',
    de: 'Frage',
    es: 'Pregunta',
    ru: 'Вопрос',
    vi: 'Câu hỏi',
  },
  a: {
    zh_cn: '解答',
    zhhant: '解答',
    en: 'Answers',
    he: 'תשובות',
    de: 'Antworten',
    es: 'Respuestas',
    ru: 'Ответы',
    vi: 'Câu trả lời',
  },
  images: {
    zh_cn: '图片',
    zhhant: '圖片',
    en: 'Images',
    he: 'תמונות',
    de: 'Bilder',
    es: 'Imágenes',
    ru: 'Изображения',
    vi: 'Hình ảnh',
  },
  language: {
    zh_cn: '语言',
    zhhant: '語言',
    en: 'Language',
    he: 'שפה',
    de: 'Sprache',
    es: 'Idioma',
    ru: 'Язык',
    vi: 'Ngôn ngữ',
  },
  content: {
    zh_cn: '内容',
    zhhant: '內容',
    en: 'Content',
    he: 'תוכן',
    de: 'Inhalt',
    es: 'Contenido',
    ru: 'Содержание',
    vi: 'Nội dung',
  },
  zhch: {
    zh_cn: '简体中文',
    zhhant: '簡體中文',
    en: '简体中文',
    he: 'סינית פשוטה',
    de: 'Vereinfachtes Chinesisch',
    es: 'Chino simplificado',
    ru: 'Упрощенный китайский',
    vi: 'Tiếng Trung giản thể',
  },
  zhhant: {
    zh_cn: '繁体中文',
    zhhant: '繁體中文',
    en: '繁体中文',
    he: 'סינית מסורתית',
    de: 'Traditionelles Chinesisch',
    es: 'Chino tradicional',
    ru: 'Традиционный китайский',
    vi: 'Tiếng Trung phồn thể',
  },
  en: {
    zh_cn: 'English',
    zhhant: '英文',
    en: 'English',
    he: 'אנגלית',
    de: 'Englisch',
    es: 'Inglés',
    ru: 'Английский',
    vi: 'Tiếng Anh',
  },
  he: {
    zh_cn: '希伯来语',
    en: 'Hebrew',
    he: 'עברית',
    de: 'Hebräisch',
    es: 'Hebreo',
    ru: 'Иврит',
    vi: 'Tiếng Hebrew',
  },
  de: {
    zh_cn: '德语',
    en: 'German',
    de: 'Deutsch',
    es: 'Alemán',
    ru: 'Немецкий',
    vi: 'Tiếng Đức',
  },
  es: {
    zh_cn: '西班牙语',
    en: 'Spanish',
    es: 'Español',
    de: 'Spanisch',
    ru: 'Испанский',
    vi: 'Tiếng Tây Ban Nha',
  },
  ru: {
    zh_cn: '俄语',
    en: 'Russian',
    ru: 'Русский',
    de: 'Russisch',
    es: 'Ruso',
    vi: 'Tiếng Nga',
  },
  vi: {
    zh_cn: '越南语',
    en: 'Vietnamese',
    vi: 'Tiếng Việt',
    de: 'Vietnamesisch',
    es: 'Vietnamita',
    ru: 'Вьетнамский',
  },
  statistics: {
    zh_cn: '充电指标',
    zhhant: '充电指標',
    en: 'Statistics',
    he: 'סטטיסטיקות',
    de: 'Statistiken',
    es: 'Estadísticas',
    ru: 'Статистика',
    vi: 'Thống kê',
  },
  requesting: {
    zh_cn: '正在请求...',
    zhhant: '正在請求...',
    en: 'Requesting...',
    he: 'מבקש...',
    de: 'Anfordern...',
    es: 'Solicitando...',
    ru: 'Запрос...',
    vi: 'Đang yêu cầu...',
  },
  requesFailed: {
    zh_cn: '请求失败',
    zhhant: '請求失敗',
    en: 'Request failed',
    he: 'שליחת בקשה נכשלה',
    de: 'Anfrage fehlgeschlagen',
    es: 'Solicitud fallida',
    ru: 'Запрос не удался',
    vi: 'Yêu cầu không thành công',
  },
  requesSuccess: {
    zh_cn: '请求成功',
    zhhant: '請求成功',
    en: 'Request success',
    he: 'בקשה נכשלה',
    de: 'Anfrage erfolgreich',
    es: 'Solicitud exitosa',
    ru: 'Запрос успешен',
    vi: 'Yêu cầu thành công',
  },
  uploading: {
    zh_cn: '正在上传...',
    zhhant: '正在上傳...',
    en: 'Uploading...',
    he: 'מעלה...',
    de: 'Hochladen...',
    es: 'Subiendo...',
    ru: 'Загрузка...',
    vi: 'Đang tải lên...',
  },
  uploadFailed: {
    zh_cn: '上传失败',
    zhhant: '上傳失敗',
    en: 'Upload failed',
    he: 'העלאה נכשלה',
    de: 'Hochladen fehlgeschlagen',
    es: 'Subida fallida',
    ru: 'Загрузка не удалась',
    vi: 'Tải lên không thành công',
  },
  uploaded: {
    zh_cn: '上传成功',
    zhhant: '上傳成功',
    en: 'Upload success',
    he: 'העלאה נכשלה',
    de: 'Hochladen erfolgreich',
    es: 'Subida exitosa',
    ru: 'Загрузка успешна',
    vi: 'Tải lên thành công',
  },
  loadFailed: {
    zh_cn: '加载失败',
    zhhant: '加載失敗',
    en: 'Load failed',
    he: 'הטעינה נכשלה',
    de: 'Laden fehlgeschlagen',
    es: 'Carga fallida',
    ru: 'Загрузка не удалась',
    vi: 'Tải không thành công',
  },
  terminalApp: {
    zh_cn: '终端应用',
    zhhant: '終端應用',
    en: 'Terminal app',
    he: 'אפליקצית טרמינל',
    de: 'Terminal-App',
    es: 'Aplicación de terminal',
    ru: 'Терминальное приложение',
    vi: 'Ứng dụng dành cho máy tính bảng',
  },
  notiConfig: {
    zh_cn: '通知配置',
    zhhant: '通知設定',
    en: 'Notification config',
    he: 'הגדרות התראות',
    de: 'Benachrichtigungs-Konfiguration',
    es: 'Configuración de notificaciones',
    ru: 'Настройки уведомления',
    vi: 'Cấu hình thông báo',
  },

  clientSecret: {
    zh_cn: '客户端密钥',
    zhhant: '用戶端密鑰',
    en: 'Client Secret',
    he: 'מפתח לקוח',
    de: 'Client-Secret',
    es: 'Secreto del cliente',
    ru: 'Секретный ключ клиента',
    vi: 'Mật khẩu của máy khách',
  },
  apiBase: {
    zh_cn: 'api 地址',
    zhhant: 'api 位址',
    en: 'API Address',
    he: 'כתובת API',
    de: 'API-Adresse',
    es: 'Dirección de la API',
    ru: 'Адрес API',
    vi: 'Địa chỉ API',
  },
  email: {
    zh_cn: '邮箱',
    zhhant: '郵箱',
    en: 'Email',
    he: 'דואר אלקטרוני',
    de: 'E-Mail',
    es: 'Correo electrónico',
    ru: 'Электронная почта',
    vi: 'Thư điện tử',
  },
  env: {
    zh_cn: '环境',
    zhhant: '環境',
    en: 'env',
    he: 'אביזיה',
    de: 'Umgebung',
    es: 'Entorno',
    ru: 'Среда',
    vi: 'Môi trường',
  },
  wait: {
    zh_cn: '等待',
    zhhant: '等待',
    en: 'Wait',
    he: 'ממתין',
    de: 'Warten',
    es: 'Esperar',
    ru: 'Ожидание',
    vi: 'Chờ',
  },
  inAction: {
    zh_cn: '活动中',
    zhhant: '活動中',
    en: 'In action',
    he: 'בפעילות',
    de: 'Im Gange',
    es: 'En acción',
    ru: 'В работе',
    vi: 'Trong hoạt động',
  },
  finish: {
    zh_cn: '已结束',
    zhhant: '已結束',
    en: 'Finish',
    he: 'הושלם',
    de: 'Beendet',
    es: 'Finalizado',
    ru: 'Завершено',
    vi: 'Hoàn thành',
  },
  list: {
    zh_cn: '列表',
    zhhant: '列表',
    en: 'List',
    he: 'רשימה',
    de: 'Liste',
    es: 'Lista',
    ru: 'Список',
    vi: 'Danh sách',
  },
  map: {
    zh_cn: '地图',
    zhhant: '地圖',
    en: 'Map',
    he: 'מפה',
    de: 'Karte',
    es: 'Mapa',
    ru: 'Карта',
    vi: 'Bản đồ',
  },
  refer: {
    zh_cn: '参考文档',
    zhhant: '參考文檔',
    en: 'Refer',
    he: 'להפנות',
    de: 'Verweisen',
    es: 'Referencia',
    ru: 'Ориентир',
    vi: 'Tham khảo',
  },
  push: {
    zh_cn: '推送',
    zhhant: '推送',
    en: 'Push',
    he: 'דחיפה',
    de: 'Schieben',
    es: 'Empujar',
    ru: 'Притиск',
    vi: 'Đẩy',
  },
  domain: {
    zh_cn: '域名',
    zhhant: '域名',
    en: 'Domain',
    he: 'שם מתחם',
    de: 'Domäne',
    es: 'Dominio',
    ru: 'Домен',
    vi: 'Tên miền',
  },
  priceingType: {
    zh_cn: '计费类型',
    zhhant: '計費類型',
    en: 'Priceing Type',
    he: 'סוג חיוב',
    de: 'Preisgestaltungstyp',
    es: 'Tipo de precio',
    ru: 'Тип ценообразования',
    vi: 'Loại giá',
  },
  commonStatePending: {
    zh_cn: '待处理',
    zhhant: '待處理',
    en: 'Pending',
    he: 'ממתין',
    es: 'Pendiente',
    ru: 'Ожидание',
    vi: 'Đang chờ',
  },
  commonStateProcess: {
    zh_cn: '处理中',
    zhhant: '處理中',
    en: 'Processing',
    he: 'מעבד',
    es: 'Procesando',
    ru: 'Обработка',
    vi: 'Đang xử lý',
  },
  commonStateFail: {
    zh_cn: '处理失败',
    zhhant: '處理失敗',
    en: 'Fail',
    he: 'נכשל',
    es: 'Fallo',
    ru: 'Неудача',
    vi: 'Thất bại',
  },
  commonStateProcessed: {
    zh_cn: '处理成功',
    zhhant: '處理成功',
    en: 'Processed',
    he: 'הובצה',
    es: 'Procesado',
    ru: 'Обработано',
    vi: 'Đã xử lý',
  },
  commonStateClose: {
    zh_cn: '关闭',
    zhhant: '關閉',
    en: 'Close',
    he: 'סגור',
    es: 'Cerrar',
    ru: 'Закрыть',
    vi: 'Đóng',
  },
  person: {
    zh_cn: '个人',
    zhhant: '個人',
    en: 'Person',
    he: 'אדם',
    es: 'Persona',
    ru: 'Лицо',
    vi: 'Người',
  },
  company: {
    zh_cn: '企业',
    zhhant: '企業',
    en: 'Company',
    he: 'חברה',
    es: 'Compañía',
    ru: 'Компания',
    vi: 'Công ty',
  },
  master: {
    zh_cn: '管理员',
    zhhant: '管理員',
    en: 'Master',
    he: 'מנהל',
    es: 'Maestro',
    ru: 'Мастер',
    vi: 'Quản trị viên',
  },
  searchUser: {
    zh_cn: '搜索用户',
    zhhant: '搜索用戶',
    en: 'Search user',
    he: 'חיפוש משתמש',
    es: 'Buscar usuario',
    ru: 'Поиск пользователя',
    vi: 'Tìm người dùng',
  },
  addWhiteList: {
    zh_cn: '添加白名单',
    zhhant: '添加白名單',
    en: 'Add white list',
    he: 'הוספת רשימת לבנה',
    es: 'Añadir a la lista blanca',
    ru: 'Добавить в белый список',
    vi: 'Thêm vào danh sách trắng',
  },
  timeGrain: {
    zh_cn: '时间粒度',
    zhhant: '時間粒度',
    en: 'Time Grain',
    he: 'טווח זמן',
    es: 'Grain de tiempo',
    ru: 'Шаг времени',
    vi: 'Đơn vị thời gian',
  },
  time: {
    zh_cn: '时间',
    zhhant: '時間',
    en: 'Time',
    he: 'זמן',
    es: 'Tiempo',
    ru: 'Время',
    vi: 'Thời gian',
  },
  totalTradeAmount: {
    zh_cn: '总交易额',
    zhhant: '總交易额',
    en: 'Total trade amount',
    he: 'סכום העסקה',
    es: 'Monto total de la transacción',
    ru: 'Общая сумма сделок',
    vi: 'Tổng số tiền giao dịch',
  },
  psTotalAmount: {
    zh_cn: '按总金额分润',
    zhhant: '按總金額分润',
    en: 'Ps total amount',
    he: 'סכום השוואה',
    es: 'Monto total de la comisión',
    ru: 'Общая сумма комиссии',
    vi: 'Tổng số tiền hoa hồng',
  },
  psServiceAmount: {
    zh_cn: '按服务费分润',
    zhhant: '按服務費分润',
    en: 'Ps service amount',
    he: 'סכום השוואה לשירות',
    es: 'Monto de la comisión de servicio',
    ru: 'Сумма комиссии за обслуживание',
    vi: 'Tổng số tiền hoa hồng cho dịch vụ',
  },
  psElectricAmount: {
    zh_cn: '按电费分润',
    zhhant: '按電費分润',
    en: 'Ps electric amount',
    he: 'סכום השוואה לתאורה',
    es: 'Monto de la comisión de electricidad',
    ru: 'Сумма комиссии за электричество',
    vi: 'Tổng số tiền hoa hồng cho điện',
  },
  walletName: {
    zh_cn: '钱包名称',
    zhhant: '錢包名稱',
    en: 'Wallet name',
    he: 'שם המסגרת',
    es: 'Nombre de la billetera',
    ru: 'Название кошелька',
    vi: 'Tên ví',
  },
  stationNature: {
    zh_cn: '站点性质',
    zhhant: '站點性質',
    en: 'Station Nature',
    he: 'אופי התחנה',
    de: 'Standorttyp',
    es: 'Naturaleza de la estación',
    ru: 'Тип станции',
    vi: 'Tính chất trạm',
  },
  phone: {
    zh_cn: '手机号',
    zhhant: '手機號',
    en: 'Phone number',
    he: 'מספר טלפון',
    de: 'Telefonnummer',
    es: 'Número de teléfono',
    ru: 'Номер телефона',
    vi: 'Số điện thoại',
  },
  referrerName: {
    zh_cn: '推荐人',
    zhhant: '推薦人',
    en: 'Referrer name',
    he: 'שם המדריך',
    de: 'Beitragername',
    es: 'Nombre del referente',
    ru: 'Имя рекомендателя',
    vi: 'Tên người khuyến nghị',
  },
  referrerPhone: {
    zh_cn: '推荐人手机号',
    zhhant: '推薦人手機號',
    en: 'Referrer phone number',
    he: 'מספר טלפון של המדריך',
    de: 'Beitragernummer',
    es: 'Número de teléfono del referente',
    ru: 'Номер телефона рекомендателя',
    vi: 'Số điện thoại của người khuyến nghị',
  },
  cooperType: {
    zh_cn: '合作方式',
    zhhant: '合作方式',
    en: 'Cooperation type',
    he: 'סוגי שיתוף',
    de: 'Kollaborationstyp',
    es: 'Tipo de cooperación',
    ru: 'Тип сотрудничества',
    vi: 'Loại hợp tác',
  },
  resetPassword: {
    zh_cn: '重置密码',
  },
  newPassword: {
    zh_cn: '新密码',
  },
  oldPassword: {
    zh_cn: '旧密码',
  },
  recordId: {
    zh_cn: '设备订单ID',
  },
  paymentOrderId: {
    zh_cn: '第三方支付单号',
  },
  userSummary: {
    zh_cn: '用户总览',
    zhhant: '用戶總覽',
    en: 'User summary',
    vi: 'Tổng quan người dùng',
    es: 'Resumen de usuario',
    ru: 'Обзор пользователя',
    he: 'עפרת משתמש',
    de: 'Benutzersübersicht',
  },
  userCount: {
    zh_cn: '用户总数',
    zhhant: '用戶總數',
    en: 'User count',
    vi: 'Số lượng người dùng',
    es: 'Número de usuarios',
    ru: 'Количество пользователей',
    he: 'סך הכרז של משתמשים',
    de: 'Benutzeranzahl',
  },
  walletCount: {
    zh_cn: '钱包总数',
    zhhant: '錢包總數',
    en: 'Wallet count',
    vi: 'Số lượng ví',
    es: 'Número de billeteras',
    ru: 'Количество кошельков',
    he: 'סך הכרז של מטבעות',
    de: 'Kontonummern',
  },
  billSummary: {
    zh_cn: '账单总览',
    zhhant: '账单總覽',
    en: 'Bill summary',
    vi: 'Tổng quan hóa đơn',
    es: 'Resumen de factura',
    ru: 'Обзор счета',
    he: 'עפרת תשלומים',
    de: 'Rechnungsübersicht',
  },
  allowApp: {
    zh_cn: '授权应用',
    zhhant: '授權應用',
    en: 'Allow app',
    vi: 'Cho phép ứng dụng',
    es: 'Permitir aplicación',
    ru: 'Разрешить приложение',
    he: 'תאפשר יישומון',
    de: 'App erlauben',
  }
}
